module.exports = new __parcel__URL__("metaMask.dfcc0ce3.svg").toString();